<template>
  <base-content>
    <base-header>Logged Out</base-header>
    <p>
      You've been logged out.
    </p>
  </base-content>
</template>

<script>
export default {
  mounted () {
    this.$store.dispatch('core/auth/logout')
  }
}
</script>
